import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/reports");

export const Route = createFileRoute("/reports/")({
  head: () => ({
    meta: [
      { title: "Reports — LevelLoad" },
      {
        name: "description",
        content: "LevelLoad product, lane, drift and SQL reports on one page.",
      },
      { property: "og:title", content: "Reports — LevelLoad" },
      {
        property: "og:description",
        content: "LevelLoad product, lane, drift and SQL reports on one page.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
